import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import Logo from "@/components/brand/Logo";

const NAV = [
  { label: "Product", to: "/#features" },
  { label: "Pricing", to: "/pricing" },
  { label: "Demo Dashboard", to: "/login" },
];

export default function MarketingNav() {
  const navigate = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const onDark = loc.pathname === "/" || loc.pathname.startsWith("/r/");

  return (
    <nav
      data-testid="marketing-nav"
      className={`fixed top-4 left-4 right-4 z-50 ${onDark ? "glass" : "bg-white/80 backdrop-blur-xl border border-border/60"} px-5 py-3 flex items-center justify-between rounded-sm`}
    >
      <Link to="/" className="flex items-center" data-testid="nav-logo-link">
        <Logo variant={onDark ? "light" : "dark"} />
      </Link>

      <div className="hidden md:flex items-center gap-8">
        {NAV.map((n) => (
          <Link
            key={n.to}
            to={n.to}
            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={`text-sm font-medium transition-colors ${onDark ? "text-ivory-200 hover:text-gold-500" : "text-navy-900 hover:text-gold-600"}`}
          >
            {n.label}
          </Link>
        ))}
      </div>

      <div className="hidden md:flex items-center gap-3">
        <button
          onClick={() => navigate("/login")}
          data-testid="nav-login-btn"
          className={`text-sm font-medium ${onDark ? "text-ivory-50" : "text-navy-900"} hover:text-gold-500`}
        >
          Log in
        </button>
        <button
          onClick={() => navigate("/signup")}
          data-testid="nav-signup-btn"
          className="text-sm font-semibold px-5 py-2.5 bg-gold-500 hover:bg-gold-400 text-navy-900 rounded-sm transition-colors"
        >
          Start Growth Autopilot
        </button>
      </div>

      <button
        onClick={() => setOpen((v) => !v)}
        className={`md:hidden ${onDark ? "text-ivory-50" : "text-navy-900"}`}
        data-testid="nav-mobile-toggle"
        aria-label="Toggle menu"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 6h18M3 12h18M3 18h18" />
        </svg>
      </button>

      {open && (
        <div className={`absolute top-full left-0 right-0 mt-2 ${onDark ? "glass" : "bg-white border border-border/60"} rounded-sm p-4 flex flex-col gap-3 md:hidden`}>
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className={`text-sm ${onDark ? "text-ivory-200" : "text-navy-900"}`} data-testid={`nav-mobile-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
              {n.label}
            </Link>
          ))}
          <button onClick={() => navigate("/signup")} className="text-sm font-semibold px-4 py-2 bg-gold-500 text-navy-900 rounded-sm" data-testid="nav-mobile-signup">
            Start Growth Autopilot
          </button>
        </div>
      )}
    </nav>
  );
}
